module.exports = __webpack_public_path__ + "img/white-logo-venx.58dc2921.png";